import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const PlayRectangleV2 = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon width="21" height="22" viewBox="0 0 21 22" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1892 17.4188H4.26071C3.32347 17.4188 2.55664 16.652 2.55664 15.7148V6.3424C2.55664 5.40091 3.31921 4.63834 4.26071 4.63834H16.1892C17.1264 4.63834 17.8933 5.40517 17.8933 6.3424V15.7148C17.8933 16.6563 17.1307 17.4188 16.1892 17.4188Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.37752 8.55701L12.4781 10.3906C12.87 10.6223 12.87 11.1898 12.4781 11.4216L9.37752 13.2551C8.97791 13.4911 8.47266 13.2032 8.47266 12.7396V9.07249C8.47351 8.60899 8.97876 8.321 9.37752 8.55701Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

PlayRectangleV2.propTypes = {
  color: PropTypes.string
};

PlayRectangleV2.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default PlayRectangleV2;
